"use client";

import { HomeHeroTrishOnboarding } from "~/components/marketplace/home-hero-trish-onboarding";
import { cn } from "~/lib/utils";

type HomeHeroBuildAgentFlowProps = {
  variant?: "home" | "standalone";
  className?: string;
};

/** Homepage hero entry — opens /agents/hire/custom (Trish) in a new tab. */
export function HomeHeroBuildAgentFlow({
  variant = "home",
  className,
}: HomeHeroBuildAgentFlowProps) {
  return (
    <HomeHeroTrishOnboarding
      variant={variant}
      className={cn(className)}
    />
  );
}
